// extracted by mini-css-extract-plugin
module.exports = {"socialBar":"home-module--social-bar--2iBXD","facebookLink":"home-module--facebook-link--2mmSq","instragramLink":"home-module--instragram-link--1Ay-H"};